import React, { useState, useEffect } from 'react'
import Header from '../../components/ReservationTennis/Header'
import TabReservation from '../../components/ReservationTennis/TabReservation/TabReservation'
import { useStyles } from './ReservationTennisStyle.js'
import { Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'

import Container from '@material-ui/core/Container'
import Card from '@material-ui/core/Card'

export default function Accueil(props) {
  const classes = useStyles()
  const state = useSelector(state => state)
  const [centre, setCentre] = useState('')
  const [date, setDate] = useState(new Date())
  const [move, setmove] = useState(false)
    
  const selectDate = (date) => {
    setDate(date)
  }

  const handleMove = (etat) => {
    setmove(etat)
  }
    
  const [list, setList] = useState({})
    
  if(state.interruptionTennis) {
    return <Redirect to="/" />
  }

  useEffect(() => {
    async function fetchData() {
      const res = await fetch(
        process.env.REACT_APP_API_PATH + 'api/reservation/centers',
        {
          method: 'get',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      )
      const json = await res.json()
      setList(json.centers)
      // permet de charger le composant après avoir fetch les données pour pouvoir afficher la defaultValue (sinon elle est vide)
    }
    fetchData()
  }, [])
            
  return (
    <div className={classes.root}>
      {!state.completedData && <Redirect to="/donnees-personnelles" />}
      <Card className={classes.card}>
        <Container className={classes.container}>
                    
          {list.length && <Header
            centerList={list}
            setCentre={setCentre}
            selectDate={selectDate}
            move={move} setmove={handleMove}
          />}

          <TabReservation move={move} setmove={handleMove} centre={centre || 43} date={date} />
        </Container>
      </Card>
    </div>
  )
}